import { Pipe, PipeTransform } from '@angular/core';
import { BcmDynamicCurrency } from '@modules/bcm/@shared/pipes/dynamic-currency.pipe';

@Pipe({
    name: 'bcmDynamicPrice',
    standalone: false
})
export class DynamicPricePipe implements PipeTransform {

    constructor(private bcmDynamicCurrency: BcmDynamicCurrency) {
    }

    transform(value: number, digitsInfo = '1.2-2', locale?: string): string {
        return this.bcmDynamicCurrency.transform(value, digitsInfo, locale);
    }
}
